import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useAdvanceSearchModalContext } from '../AdvanceSearchModal.hook';
import { tAdvanceSearchFilters } from '../AdvanceSearchModal.types';

export default function InfoSection() {
  const { totalLeads, areFiltersActive, setLastFilters } =
    useAdvanceSearchModalContext();
  const { t } = useTranslation('navbar/navbar');

  const filtersFromLocalStorage = localStorage.getItem('advanceSearchFilters');
  const previousFilters: tAdvanceSearchFilters | null = filtersFromLocalStorage
    ? JSON.parse(filtersFromLocalStorage)
    : null;
  const showPreviousFiltersButton =
    !!previousFilters &&
    !areFiltersActive &&
    !!Object.values(previousFilters).filter((value) =>
      Array.isArray(value) ? !!value[1] : !!value,
    ).length;

  return (
    <div className="AdvanceSearchModal__Body__InfoContainer">
      {totalLeads ? (
        <p className="font-sans">
          {areFiltersActive ? (
            <>
              {t('advanceSearch.searchResults')}:{' '}
              <span className="text-primary">
                {totalLeads} {t('advanceSearch.results')}
              </span>
            </>
          ) : (
            t('advanceSearch.lastInteraction')
          )}
        </p>
      ) : null}
      <div className="flex-1 flex justify-end">
        {showPreviousFiltersButton ? (
          <Button
            variant="link"
            onClick={() => {
              setLastFilters(previousFilters);
            }}
          >
            {t('advanceSearch.lastSearch')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
